import * as React from 'react';
import { connect } from 'react-redux';
import { useQuery } from 'react-query';
import { renderRoutes } from "react-router-config";
import { withTranslation } from 'react-i18next';

import StudentNavBar from './navbar/studentNavbar';
import TeacherNavbar from './navbar/teacherNavbar';

import { DIAGNOSTIC } from '../../Shared/utils/constants';
import { addKeyDownListener } from '../../Shared/hooks/addKeyDownListener';
import { ReadAloudProvider, ScreenreaderInstructions, TeacherPreviewMenu, defaultLanguages, getParameterByName, hasTeacherPreview } from '../../Shared/index';
import { fetchUserRole } from '../../Shared/utils/userAPIs';
import { routes } from "../routes";
import i18n from '../../Shared/libs/translations/i18n';
import { updateLanguage } from '../actions/diagnostics.js';
// TODO: standardize Question Typescript interface definitions
import { Question } from '../../Grammar/interfaces/questions';

export const Home = ({ dispatch, playDiagnostic, lessons, t }) => {
  const studentSession = getParameterByName('student', window.location.href);
  const turkSession = window.location.href.includes('turk');
  const studentOrTurk = studentSession || turkSession;
  const isPlaying = window.location.href.includes('play');
  const { data: roleData } = useQuery("user-role", fetchUserRole);
  const isTeacherOrAdmin = roleData && roleData.role && roleData.role !== 'student';

  const [showFocusState, setShowFocusState] = React.useState<boolean>(false);
  const [previewShowing, setPreviewShowing] = React.useState<boolean>(!studentOrTurk || hasTeacherPreview());
  const [questionToPreview, setQuestionToPreview] = React.useState<any>(null);
  const [switchedBackToPreview, setSwitchedBackToPreview] = React.useState<boolean>(false);
  const [skippedToQuestionFromIntro, setSkippedToQuestionFromIntro] = React.useState<boolean>(false);

  function handleKeyDown (e: any) {
    if (e.key !== 'Tab') { return }
    if (showFocusState) { return }

    setShowFocusState(true);
  }

  addKeyDownListener(handleKeyDown);

  function handleSkipToMainContentClick () {
    const element = document.getElementById("main-content")
    if (!element) { return }
    element.focus()
    element.scrollIntoView()
  }

  function handleTogglePreviewMenu () {
    if(previewShowing) {
      setSwitchedBackToPreview(false);
    } else {
      setSwitchedBackToPreview(true);
    }
    setPreviewShowing(!previewShowing);
  }

  function handleToggleQuestion (question: Question) {
    setQuestionToPreview(question);
  }

  function handleSkipToQuestionFromIntro () {
    setSkippedToQuestionFromIntro(true);
  }

  function handleUpdateLanguage(language) {
    i18n.changeLanguage(language);
    dispatch(updateLanguage(language));
  }

  let className = "ant-layout "
  className = showFocusState ? '' : 'hide-focus-outline'
  const showPreview = previewShowing && (isTeacherOrAdmin || hasTeacherPreview()) && isPlaying;
  const isOnMobile = window.innerWidth < 1100;
  const isELLDiagnostic = lessons?.data && playDiagnostic?.diagnosticID && lessons.data[playDiagnostic.diagnosticID]?.isELL
  return(
    <ReadAloudProvider activitySessionUid={studentSession} tool={DIAGNOSTIC}>
      <div className={className}>
        <ScreenreaderInstructions />
        <button className="skip-main" onClick={handleSkipToMainContentClick} type="button">Skip to main content</button>
        {isPlaying && !isTeacherOrAdmin && !hasTeacherPreview() && (
          <StudentNavBar
            isELLDiagnostic={isELLDiagnostic}
            language={playDiagnostic?.language}
            translate={t}
            updateLanguage={handleUpdateLanguage}
          />
        )}
        {isPlaying && (isTeacherOrAdmin || hasTeacherPreview()) &&
          <TeacherNavbar
            isELLDiagnostic={isELLDiagnostic}
            isOnMobile={isOnMobile}
            language={playDiagnostic?.language}
            onTogglePreview={handleTogglePreviewMenu}
            previewShowing={previewShowing}
            translate={t}
            updateLanguage={handleUpdateLanguage}
          />}
        <div className="activity-container">
          {showPreview && <div className="sider-container">
            <TeacherPreviewMenu
              isOnMobile={isOnMobile}
              onHandleSkipToQuestionFromIntro={handleSkipToQuestionFromIntro}
              onTogglePreview={handleTogglePreviewMenu}
              onToggleQuestion={handleToggleQuestion}
              questionToPreview={questionToPreview}
              showPreview={previewShowing}
            />
          </div>}
          <main>
            <div id="main-content" tabIndex={-1}>{renderRoutes(routes, {
              isOnMobile: isOnMobile,
              handleTogglePreview: handleTogglePreviewMenu,
              switchedBackToPreview: switchedBackToPreview,
              handleToggleQuestion: handleToggleQuestion,
              previewMode: showPreview,
              questionToPreview: questionToPreview,
              skippedToQuestionFromIntro: skippedToQuestionFromIntro,
              translate: t
            })}</div>
          </main>
        </div>
      </div>
    </ReadAloudProvider>
  );
}

const select = (state: any, props: any) => {
  return {
    playDiagnostic: state.playDiagnostic,
    lessons: state.lessons
  };
}

export default withTranslation()(connect(select)(Home));
